<template>
    <div class="server-error">
        <div class="header bg-primary d-flex align-center px-3">
            <img
                src="/images/kaamfu-text-logo.png"
                alt="Server Image"
                width="61"
                height="20"
                style="object-fit: contain"
            />
        </div>
        <div class="content d-flex align-center justify-center">
            <div class="content_ui">
                <div class="d-flex align-start justify-start ga-4">
                    <div class="custom-avatar">
                        <img
                            src="/images/broken.svg"
                            alt="Broken"
                            class="custom-avatar-img"
                        />
                    </div>
                    <div class="w-100">
                        <h2 class="text-priamry">Invalid Link</h2>
                        <v-divider class="my-3" />
                        <p class="pr-6">
                            The password link is invalid or has expired. Please
                            <span class="font-weight-bold"> request</span> a new
                            password reset link or try to
                            <span class="font-weight-bold">sign in again.</span>
                        </p>
                    </div>
                </div>
                <v-divider class="my-4" />
                <div class="d-flex justify-end">
                    <VBtn
                        variant="plain"
                        class="px-3"
                        :style="{ fontWeight: 400 }"
                        rounded
                        href="/"
                        >SIGN IN AGAIN</VBtn
                    >
                    <VBtn
                        variant="outlined"
                        rounded="xl"
                        :style="{ fontWeight: 400, paddingTop: '2px' }"
                        @click="showForgotPwd = true"
                        >REQUEST NEW LINK</VBtn
                    >
                </div>
            </div>
        </div>
    </div>
    <Transition v-if="showForgotPwd" duration="550" name="nested">
        <ForgotPassword @close="showForgotPwd = false"></ForgotPassword>
    </Transition>
</template>

<script setup>
import { ref, onMounted } from "vue";
import ForgotPassword from "../Components/Modal/ForgotPassword.vue";

const showForgotPwd = ref(false);

onMounted(() => {
    localStorage.setItem("isDarkPage", JSON.stringify({ dark: false }));
});
</script>
<style lang="scss" scoped>
.server-error {
    .header {
        height: 41px;
    }
    .content {
        height: calc(100vh - 41px);
        .content_ui {
            width: 30rem;
        }
    }
}

.custom-avatar {
    width: 100%;
    max-width: 80px;
    height: auto;

    .custom-avatar-img {
        width: 100%;
        height: auto;
        border-radius: 0;
    }
}
</style>
